/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingHomeIcon20Solid = forwardRef('BuildingHomeIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.477 2.293.914 8.26C.238 8.875.673 10 1.587 10H4v5a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-5h2.413c.914 0 1.35-1.125.673-1.74l-6.563-5.967a3.75 3.75 0 0 0-5.046 0Z" })));
});
